var Student = "Student";
var jobRole = {
	"Job role": "Job role",
	"Academic / Researcher": "Academic / Researcher",
	"Advisor / Consultant": "Advisor / Consultant",
	"Business Executive": "Business Executive",
	"Developer / Engineer": "Developer / Engineer",
	"Entrepreneur (Founder/Co-Founder)": "Entrepreneur (Founder/Co-Founder)",
	"IT Executive": "IT Executive",
	"IT Professional or Technical Manager": "IT Professional or Technical Manager",
	"Press / Media Analyst": "Press / Media Analyst",
	"Sales / Marketing": "Sales / Marketing",
	Student: Student,
	"Solution or Systems Architect": "Solution or Systems Architect",
	"System Administrator": "System Administrator",
	"Venture Capitalist": "Venture Capitalist"
};

export { Student, jobRole as default };
